import { Injectable } from '@angular/core';

@Injectable()
export class TokenService {

    getToken(): string {
        return solid.auth.getToken();
    }

    getTokenCookieName(): string {
        return solid.auth.tokenCookieName;
    }

    clearToken(): void {
        solid.auth.clearToken();
    }

    setToken(authToken: string, expireDate?: Date): void {
        solid.auth.setToken(authToken, expireDate);
    }

}